import React, { FC, useMemo } from 'react';
import { useRequestController } from '@sg/hooks/useRequestController';
import GPSelect from '@gp/components/Select';
import { SELECT_PANEL_HEIGHT } from '@gp/constants/const';
import GPSelectMultiple from '@gp/components/SelectMultiple';
import classnames from 'classnames';
interface Props<T extends unknown = string> {
  value: T;
  onChange: (value: string) => void;
  isSingle: boolean;
  [key: string]: any;
}

const LiveTitleFilter: FC<Props> = ({
  value,
  onChange,
  isSingle = true,
  ...restProps
}) => {
  const { data } = useRequestController({
    method: 'POST',
    url: '/api/v1/globalpedia_pc/cond',
    staleTime: 300000,
    refreshDeps: useMemo(
      () => ({
        live_title_country_code: null,
        live_title_os: null,
        live_title_studio_game: null,
      }),
      [],
    ),
  });

  const sortByStudioGame = (list: any) => {
    const listB = ['Path of Exile 2', 'Path of Exile', 'Dune:Awakening'];
    const listSort = Array.isArray(list) ? [...list] : [];
    listSort.sort((a, b) => {
      const indexA = listB.indexOf(a.text);
      const indexB = listB.indexOf(b.text);

      // 两个元素都在listB中
      if (indexA !== -1 && indexB !== -1) {
        return indexA - indexB;
      }

      // 只有a在listB中
      if (indexA !== -1) return -1;

      // 只有b在listB中
      if (indexB !== -1) return 1;

      // 都不在listB中，按字母排序
      return a.text?.localeCompare(b.text);
    });
    return listSort;
  };

  const list = useMemo(() => {
    const list = data?.live_title_studio_game
      ?.flatMap((studio) => studio.game_titles)
      .filter((game, index, self) => self.indexOf(game) === index)
      ?.map((task) => ({
        text: task,
        value: task,
        groupKey: 'separated',
      }));
    const defaultValue = list?.find(
      (item: { value: string; }) => item.value === 'Path of Exile 2',
    )?.value;
    isSingle && onChange(defaultValue || list?.[0]?.value || null);

    const listCur = sortByStudioGame(list);

    return listCur;
  }, [data?.live_title_studio_game, isSingle, onChange]);
  const Select = isSingle ? GPSelect : GPSelectMultiple;
  return (
    <Select
      overlayClassName={classnames(
        {
          'dbp-metrics-card-with-rank__right-tab-select': isSingle,
        },
      )}
      style={{ marginRight: 10 }}
      listHeight={SELECT_PANEL_HEIGHT}
      options={list}
      searchable
      label="Title"
      enableStickySelection={true}
      value={value}
      onChange={(res)=>{
        if (!isSingle) {
          if (value.length === 1 && !value[0] && res?.length === list?.length) {
            return;
          }
        }
        onChange(res);
      }}
      {...restProps}
    />
  );
};

export default LiveTitleFilter;
